import { IndentValues } from "@/lib/utils/IndentValues";
import { Box, Indent, Txt } from "@stenajs-webui/core";
import { Tooltip } from "@stenajs-webui/tooltip";

interface Props {
  tooltipLabel: string;
  value: string;
  truncate?: boolean;
}

export const CellWithTooltip = ({ tooltipLabel, value, truncate }: Props) => {
  const cell = (
    <Tooltip label={tooltipLabel} appendTo={document.body}>
      <Indent num={IndentValues.EIGHT}>
        <Txt
          style={{ fontWeight: "500" }}
          overflow={truncate ? "hidden" : undefined}
          textOverflow={truncate ? "ellipsis" : undefined}
          whiteSpace={truncate ? "nowrap" : undefined}
        >
          {value}
        </Txt>
      </Indent>
    </Tooltip>
  );

  return truncate ? (
    <Box width={"calc(100% - 8px)"} overflow={"hidden"}>
      {cell}
    </Box>
  ) : (
    cell
  );
};
